import React from 'react';
import PropTypes from 'prop-types';

/**
 * CartIcon — the header's shopping-bag icon (Figma 3676:23645), stroked in
 * `currentColor` like a lucide icon so a Button sizes and tints it.
 *
 * `plus` draws a plus inside the bag, where the header prints the item count
 * — an "add to cart" CTA. The header keeps
 * its count as its own badge over the plain icon.
 */
const STROKE = {
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const CartIcon = ({ plus = false, size = 24, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(size * 22) / 24}
    height={size}
    viewBox="0 0 22 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={['ds-cart-icon', className].filter(Boolean).join(' ')}
  >
    <path {...STROKE} d="M15.1002 9.18269V5.10577C15.1002 2.76918 13.2086 0.875 10.8751 0.875C8.54162 0.875 6.64997 2.76918 6.64997 5.10577V9.18269M19.4448 7.93444L20.868 21.4729C20.9468 22.2223 20.36 22.875 19.6074 22.875H2.14276C1.39023 22.875 0.803413 22.2223 0.882192 21.4729L2.30539 7.93444C2.3733 7.28847 2.91729 6.79808 3.56596 6.79808H18.1842C18.8329 6.79808 19.3769 7.28847 19.4448 7.93444Z" />
    {plus && <path {...STROKE} className="ds-cart-icon__plus" d="M10.875 12.75V18.25M8.125 15.5H13.625" />}
  </svg>
);

CartIcon.propTypes = {
  /** A plus inside the bag (where the header shows the count) — "add to cart" */
  plus: PropTypes.bool,
  /** Height in px (the width keeps the 22:24 shape); a Button's icon slot sizes it anyway */
  size: PropTypes.number,
  /** Additional CSS class on the svg */
  className: PropTypes.string,
};

export default CartIcon;
